module.exports = require('./helpers/bundle-url').getBundleURL('sdbCj') + "Privacy Policy.b9e08d55.pdf";